/**
 * unread_badge_v1: จำว่าแอดมิน "เปิดอ่าน" แต่ละเคสครั้งล่าสุดเมื่อไหร่
 *
 * ทำไมเก็บฝั่ง client:
 *   ฝั่งแชทลูกค้าไม่มี endpoint mark-read (ต่างจากแชทพนักงานที่มี POST .../read)
 *   และโค้ดเดิมไม่เคยอ่านค่า unread_count จาก API เลย — มีแต่บวกเพิ่มเองใน SSE handler
 *   จึงยืนยันไม่ได้ว่า backend ส่ง field นั้นมาจริง เลยทำให้ badge ทำงานได้ด้วยตัวเองก่อน
 *   ถ้าภายหลังมี endpoint ฝั่ง server ค่อยเสียบเพิ่มทีหลังได้โดยไม่ต้องรื้อ
 *
 * เก็บแยกตามผู้ใช้ เพราะเครื่องเดียวอาจมีหลายคนสลับกันใช้
 */

const PREFIX = 'inbox_read_marks_v1';
const MAX_ENTRIES = 300; // กัน localStorage บวมเมื่อใช้ไปนานๆ

function storageKey() {
  let uid = '';
  try {
    uid = String((JSON.parse(localStorage.getItem('tenant') || '{}') || {}).id || '');
  } catch (e) { uid = ''; }
  return `${PREFIX}:${uid}`;
}

export function loadReadMarks() {
  try {
    const raw = localStorage.getItem(storageKey());
    const parsed = raw ? JSON.parse(raw) : {};
    return (parsed && typeof parsed === 'object') ? parsed : {};
  } catch (e) {
    return {};
  }
}

export function saveReadMarks(marks) {
  try {
    let toSave = marks;
    const keys = Object.keys(marks);
    if (keys.length > MAX_ENTRIES) {
      // เก็บเฉพาะรายการที่อ่านล่าสุด
      const kept = keys.sort((a, b) => marks[b] - marks[a]).slice(0, MAX_ENTRIES);
      toSave = {};
      kept.forEach((k) => { toSave[k] = marks[k]; });
    }
    localStorage.setItem(storageKey(), JSON.stringify(toSave));
    return toSave;
  } catch (e) {
    return marks;
  }
}

/**
 * สรุปสถานะยังไม่อ่านของ 1 เคส
 *   count > 0  -> รู้จำนวนแน่ชัด (นับจากข้อความที่เข้ามาทาง SSE หลังอ่านครั้งล่าสุด)
 *   count = 0 แต่ unread = true -> รู้ว่ามีของใหม่ แต่ไม่รู้จำนวน (เช่นเพิ่งรีเฟรชหน้า) -> แสดงเป็นจุด
 */
export function unreadStatus(conv, marks, liveCounts) {
  const lastAt = conv.last_message_at ? new Date(conv.last_message_at).getTime() : 0;
  if (!lastAt) return { unread: false, count: 0 };

  const readAt = marks[conv.id] || 0;
  if (readAt >= lastAt) return { unread: false, count: 0 };

  return { unread: true, count: (liveCounts && liveCounts[conv.id]) || 0 };
}
